import React from "react";
import {css} from "@emotion/react";

import {backgroundColor, borderRadius, calculateRemSize, flexAbsoluteCenter} from "@pg-design/helpers-css-strings";
import {ChevronRightIcon} from "@pg-design/icons";

export const SimpleSliderArrowRight = () => {
    return (
        <div css={arrowStyle}>
            <ChevronRightIcon size="1.2" />
        </div>
    );
};

const arrowStyle = css`
    ${flexAbsoluteCenter};
    ${backgroundColor("#fff")};
    width: ${calculateRemSize(4)};
    height: ${calculateRemSize(4)};
    ${borderRadius(2)};
    user-select: none;
`;
import React from "react";
import {css} from "@emotion/react";

import {backgroundColor, borderRadius, calculateRemSize, flexAbsoluteCenter} from "@pg-design/helpers-css-strings";
import {ChevronRightIcon} from "@pg-design/icons";

export const SimpleSliderArrowRight = () => {
    return (
        <div css={arrowStyle}>
            <ChevronRightIcon size="1.2" />
        </div>
    );
};

const arrowStyle = css`
    ${flexAbsoluteCenter};
    ${backgroundColor("#fff")};
    width: ${calculateRemSize(4)};
    height: ${calculateRemSize(4)};
    ${borderRadius(2)};
    user-select: none;
`;
